module.exports = __webpack_public_path__ + "img/img5.10c4f733.png";